<template>
  <div>
    <el-dialog
      @close="onClose"
      :visible="modalConfig.visible"
      title="分销订单"
      destroy-on-close
      :close-on-click-modal="false"
      width="80%"
      @closed="closed"
    >
      <div class="text item changepass_content">
        <div class="title-text">订单信息</div>
        <el-form
          :model="ruleForm"
          status-icon
          ref="ruleForm"
          label-width="120px"
          class="form-container"
          size="small"
          :rules='rules'
        >
          <el-form-item
            v-if="modalConfig.data.id"
            class="form-item"
            :required="modalConfig.data.type !== 'view'"
            label="订单编号"
          >
            <el-input
              disabled
              class="control"
              v-model="ruleForm.orderCode"
              placeholder="请输入订单编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="form-item"
            :required="modalConfig.data.type !== 'view'"
            label="大客户"
          >
            <el-select
              class="control"
              placeholder="请选择大客户"
              v-model="ruleForm.ext19"
              clearable
              :disabled="formDisabled || orderSourceState"
              :loading="bigCustomerLoading"
              filterable
              remote
              ref="bigCustomer"
              :remote-method="getBigCustomerData"
              @change="getBigCustomerChange"
            >
              <el-option
                v-for="item in bigCustomersList"
                :key="item.customerOrgCode"
                :value="item.customerOrgCode"
                :label="item.unionName"
                @click.native="bigCustomerFocus"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="form-item"
            :required="modalConfig.data.type !== 'view'"
            label="分销单类型"
          >
            <el-select
              class="control"
              placeholder="请选择分销单类型"
              v-model="ruleForm.orderSource"
              clearable
              :disabled="formDisabled || orderSourceState"
              @change="distributionTypeChange"
            >
              <el-option
                v-for="item in orderTypeData"
                :key="item.dictCode"
                :value="item.dictCode"
                :label="item.dictValue"
                :disabled="
                  ruleForm.ext19 === '00' &&
                    item.dictCode !== 'order_source_dis_terminal'
                "
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="distributionType === 'order_source_dis_dacang'"
            :required="modalConfig.data.type !== 'view'"
            class="form-item"
            label="分销大仓"
            prop='clientCode'
          >
            <el-select
              class="control"
              placeholder="请选择分销大仓"
              v-model="ruleForm.clientCode"
              clearable
              :disabled="formDisabled"
              :loading="bigCustomerLoading"
              filterable
              remote
              :remote-method="getBigWarehouseData"
              @focus="getBigWarehouseData()"
              @change="bigCustomerChange"
            >
              <el-option
                v-for="item in bigWarehouseList"
                :key="item.customerOrgCode"
                :value="item.customerOrgCode"
                :label="item.unionName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-else
            class="form-item"
            label="分销终端"
            prop='clientCode'
          >
            <el-select
              class="control"
              placeholder="请选择分销终端"
              v-model="ruleForm.clientCode"
              clearable
              :disabled="formDisabled"
              :loading="bigTerminalLoading"
              filterable
              remote
              :remote-method="getTerminalData"
              @focus="getTerminalData()"
              @change="bigTerminalChange"
            >
              <el-option
                v-for="item in terminalList"
                :key="item.terminalCode"
                :value="item.terminalCode"
                :label="item.unionName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-item" label="联系人">
            <el-input
              class="control"
              placeholder="请输入联系人"
              :disabled="formDisabled"
              v-model="ruleForm.contacts"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="form-item" label="电话">
            <el-input
              class="control"
              placeholder="请输入电话"
              :disabled="formDisabled"
              v-model="ruleForm.telephone"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="form-item"
            label="发货日期"
            prop='expectReceive'
          >
            <el-date-picker
              class="control"
              v-model="ruleForm.expectReceive"
              size="small"
              :disabled="formDisabled"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择发货日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="form-item" label="备注">
            <el-input
              class="control"
              type="textarea"
              placeholder="请输入备注"
              :disabled="formDisabled"
              v-model="ruleForm.remarks"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="form-item"
            :required="modalConfig.data.type !== 'view'"
            label="实际发货日期"
          >
            <el-date-picker
              class="control"
              v-model="ruleForm.ext11"
              size="small"
              disabled
              type="date"
              value-format="yyyy-MM-dd"
              placeholder=""
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="title-text">商品信息</div>
        <div class="goods-container">
          <div class="btn-container" v-if="!(isDelivery || isView)">
            <el-button size="mini" @click="selectGoods">选择商品</el-button>
            <el-button size="mini" type="danger" @click="delGoods"
              >删除商品</el-button
            >
          </div>
          <el-table
            style="width: 100%"
            height="400px"
            :data="goodsData"
            @selection-change="handleSelectionChange"
          >
            <el-table-column label="全选" type="selection"></el-table-column>
            <template v-for="(item, index) in table_data_head">
              <el-table-column
                v-if="item.prop === 'quantity' && !(isDelivery || isView)"
                :key="index"
                :width="item.width || '150'"
                :prop="item.prop"
                :label="item.label"
              >
                <template slot-scope="scope">
                  <el-input-number
                    size="mini"
                    :min="0"
                    @change="priceNumberChange(scope.row)"
                    v-model="scope.row.quantity"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                v-else-if="item.prop === 'price' && !(isDelivery || isView)"
                :key="index"
                :width="item.width || '150'"
                :prop="item.prop"
                :label="item.label"
              >
                <template slot-scope="scope">
                  <el-input-number
                    size="mini"
                    :min="0"
                    @change="priceNumberChange(scope.row)"
                    v-model="scope.row.price"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                v-else-if="item.prop === 'realStock' && (isDelivery || !isView)"
                :key="index"
                :width="item.width || '120'"
                :prop="item.prop"
                :label="item.label"
              ></el-table-column>
              <el-table-column
                v-else-if="item.prop === 'ext23' && (isDelivery || !isView)"
                :key="index"
                :width="item.width || '150'"
                :prop="item.prop"
                :label="item.label"
              >
                <template slot-scope="scope" v-if="isDelivery">
                  <el-input-number
                    size="mini"
                    :min="0"
                    v-model="scope.row.ext23"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                v-else-if="item.prop === 'ext24' && modalConfig.data.type === 'return'"
                :key="index"
                :width="item.width || '150'"
                :prop="item.prop"
                :label="item.label"
              >
                <template slot-scope="scope">
                  <el-input-number
                    size="mini"
                    :min="0"
                    v-model="scope.row.ext24"
                    :disabled="modalConfig.data.isCurrentMonth"
                  ></el-input-number>
                </template>
              </el-table-column>              
              <!-- <el-table-column
                v-else-if="item.prop === 'itmeType'"
                :key="index"
                :width="item.width || '150'"
                :prop="item.prop"
                :label="item.label"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.itmeType == 1">本品</span>
                  <span v-else-if="scope.row.itmeType == 2">赠品</span>
                  <span v-else></span>
                </template>
              </el-table-column> -->
              <el-table-column
                v-else
                :key="index"
                :min-width="item.width || '100'"
                :prop="item.prop"
                :label="item.label"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClose">
          取 消
        </el-button>
        <el-button
          :loading="btnLoading"
          type="primary"
          size="small"
          @click="submitFrom"
          v-if="modalConfig.data.type !== 'view'"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    <distributionorderSelectGoods
      :modalConfig="selectGoodsModalConfig"
      @onClose="closeSelectGoodsModal"
      @submit="selectGoodsSubmit"
    />
  </div>
</template>

<script>
import distributionorderSelectGoods from './distributionorderSelectGoods.vue'
import { getBatchDictSelect } from '@/api/api'
import request from '@/utils/request'
import { Storage } from '@/utils/storage'
export default {
  components: { distributionorderSelectGoods },
  props: {
    modalConfig: {
      type: Object,
      default: () => ({
        visible: false,
        data: {},
      }),
    },
  },
  data: () => ({
    ruleForm: {
      orderCode: '', //订单编号
      ext19: '', //大客户编码
      ext20: '', //大客户名称
      orderSource: '', //分销单类型
      clientCode: '', //大仓/终端编码
      clientName: '', //大仓/终端名称
      contacts: '', //联系人
      telephone: '', //电话
      expectReceive: '', //期望发货时间发货日期
      ext11: '', //实际发货时间
      remarks: '', //备注
      ext11: '', //实际发货日期
    },
    goodsData: [],
    selectRow: [], //表格选中数据
    table_data_head: [
      { label: '产品名称', prop: 'productName' },
      { label: '产品层级', prop: 'seriesName' },
      { label: '产品数量', prop: 'quantity' },
      { label: '单位', prop: 'unitName' },
      { label: '终端进货价', prop: 'price' },
      { label: '总金额', prop: 'ext22' },
      { label: '活动名称', prop: 'ext12' },
    ],
    btnLoading: false,
    selectGoodsModalConfig: {
      visible: false,
      data: {},
    },
    formDisabled: false,
    distributionType: '', //分销单类型
    bigCustomerLoading: false,
    bigCustomersList: [], //大客户下拉数据
    sfa_order_source: [], //分销单类型下拉数据
    bigWarehouseList: [], //大仓下拉数据
    bigWarehouseLoading: false,
    terminalList: [], //终端下拉数据
    bigTerminalLoading: false,
    isDelivery: false,
    isView: false,
    bigcustomerOrgCode: '',
    typeItemDict: [], //行项目数据字典
    rules: {
      clientCode: [
        { required: true, message: '分销终端不能为空', trigger: 'change' }
      ],
      expectReceive: [
        { required: true, message: '发货日期不能为空', trigger: 'change' }
      ]
    },
    orderSourceState: false,
    sourceList: ['order_source_dis_dacang', 'order_source_dis_terminal'],
    showReturnProduct:false
  }),
  watch: {
    modalConfig: {
      deep: true,
      handler(v) {
        console.log(v)
        if (v.visible) {
          if (v.data.id) {
            this.orderSourceState = v.data.type === 'edit' && !this.sourceList.includes(v.data.orderSource)
            if(v.data.type && v.data.type === 'return'){
              this.getReturnDetail()
            }else{
              this.getDetail()
            }
            if (v.data.type === 'delivery') {
              this.formDisabled = true
              this.getBatchDictSelect()
              this.isDelivery = true
              this.table_data_head = [
                { label: '产品名称', prop: 'productName', width: '200px' },
                { label: '产品层级', prop: 'seriesName' },
                { label: '产品数量', prop: 'quantity' },
                { label: '实发数', prop: 'ext23' },
                { label: '单位', prop: 'unitName' },
                { label: '终端进货价', prop: 'price' },
                { label: '总金额', prop: 'ext22' },
                { label: '库存', prop: 'realStock' },
                { label: '活动名称', prop: 'ext12' },
              ]
            } else if (v.data.type === 'view' || v.data.type === 'return' ) {
              this.formDisabled = true
              this.getBatchDictSelect()
              this.isDelivery = false
              this.isView = true
              this.table_data_head = [
                { label: '产品名称', prop: 'productName', width: '200px' },
                { label: '行项目类型', prop: 'itmeTypeName' },
                { label: '产品层级', prop: 'seriesName' },
                { label: '产品数量', prop: 'quantity' },
                { label: '单位', prop: 'unitName' },
                { label: '终端进货价', prop: 'price' },
                { label: '总金额', prop: 'terminalTotalAmount' },
                { label: '库存', prop: 'realStock' },
                { label: '实发数', prop: 'ext23' },
                { label: '退货数', prop: 'ext24' },
                { label: '活动编码', prop: 'ext11' },
                { label: '活动名称', prop: 'ext12' },
              ]
            } else {
              this.table_data_head = [
                { label: '产品名称', prop: 'productName', width: '200px' },
                { label: '产品层级', prop: 'seriesName' },
                { label: '产品数量', prop: 'quantity' },
                { label: '单位', prop: 'unitName' },
                { label: '终端进货价', prop: 'price' },
                { label: '总金额', prop: 'ext22' },
                { label: '活动名称', prop: 'ext12' },
              ]
              this.formDisabled = false
              this.getBatchDictSelect()
              this.isDelivery = false
              this.isView = false
            }
          } else {
            this.table_data_head = [
              { label: '产品名称', prop: 'productName', width: '200px' },
              { label: '产品层级', prop: 'seriesName' },
              { label: '产品数量', prop: 'quantity' },
              { label: '单位', prop: 'unitName' },
              { label: '终端进货价', prop: 'price' },
              { label: '总金额', prop: 'ext22' },
              { label: '活动名称', prop: 'ext12' },
            ]
            this.formDisabled = false
            this.isDelivery = false
            this.isView = false
          }
        }
      },
    },
    distributionType: {
      immediate: true,
      deep: true,
      handler(val){
        if(val && val === 'order_source_dis_dacang'){
          this.rules['clientCode'][0].message = '分销大仓不能为空'
        }else{
          this.rules['clientCode'][0].message = '分销终端不能为空'
        }
      }
    }
  },
  mounted() {
    this.getBatchDictSelect()
    this.getBigCustomerData()
    this.getTerminalData()
  },
  computed: {
    orderTypeData: function() {
      if (this.ruleForm.ext19 === '') {
        return this.sfa_order_source.filter(
          (item) => item.dictCode === 'order_source_dis_terminal'
        )
      } else {
        return this.sfa_order_source
      }
    },
  },
  methods: {
    //关闭完成后的回调
    closed() {
      this.ruleForm = {
        orderCode: '', //订单编号
        ext19: '', //大客户编码
        ext20: '', //大客户名称
        orderSource: '', //分销单类型
        clientCode: '', //大仓/终端编码
        clientName: '', //大仓/终端名称
        contacts: '', //联系人
        telephone: '', //电话
        ext12: '', //发货日期
        remarks: '', //备注
        ext11: '', //实际发货日期
      }
      this.goodsData = []
    },
    //表格选择事件
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //关闭弹窗
    onClose() {
      this.$emit('onClose')
    },
    //关闭选择商品弹窗
    closeSelectGoodsModal() {
      this.selectGoodsModalConfig.visible = false
    },
    //打开选择商品弹窗
    selectGoods() {
      this.selectGoodsModalConfig.visible = true
      this.selectGoodsModalConfig.data = {
        customerOrgCode: this.ruleForm.ext19,
      }
    },
    // 获取数据字典
    getBatchDictSelect() {
      const params = ['sfa_order_source']
      getBatchDictSelect(params).then((res) => {
        if (res.success) {
          if (this.formDisabled || this.orderSourceState) {
            this.sfa_order_source = res.result.sfa_order_source
          } else {
            this.sfa_order_source = res.result.sfa_order_source.filter((item) =>
              this.sourceList.includes(item.dictCode)
            )
          }
          // const sfa_order_source_in = ['order_source_dis_dacang', 'order_source_dis_terminal','order_source_tpm_act','order_source_visit','order_source_workbench','order_source_scheme']
        }
      })
    },
    //获取大客户下拉数据
    getBigCustomerData(query) {
      console.log(localStorage.getItem('customerCode'))
      let params = {
        // unionName: query,
        // customerOrgLevel: '1',
        customerCode: localStorage.getItem('customerCode'),
      }
      this.bigCustomerLoading = true
      request
        .post(
          '/mdm/hdMdmCustomerOrgController/findCustomerOrgSelectListByCustomerCode',
          params
        )
        .then((res) => {
          if (res.success) {
            let newCustomersList = [
              {
                customerOrgCode: '',
                customerOrgLevel: '',
                customerOrgName: '请选择',
                customerOrgType: '',
                id: '',
                unionName: '请选择',
              },
            ]
            this.bigCustomerLoading = false
            this.bigCustomersList = [...newCustomersList, ...res.result]
          }
        })
        .catch((err) => {
          this.bigCustomerLoading = false
        })
    },
    //大客户focus事件
    bigCustomerFocus() {
      this.$confirm('是否更换大客户，更换后数据丢失?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$refs.bigCustomer.blur()
          const e = this.ruleForm.ext19
          this.bigcustomerOrgCode = e
          this.ruleForm.ext20 = this.bigCustomersList.find(
            (item) => item.customerOrgCode === e
          ).customerOrgName
          if (
            e === '' &&
            this.ruleForm.orderSource !== 'order_source_dis_terminal'
          ) {
            this.ruleForm.orderSource = ''
          }
          this.ruleForm.orderSource = ''
          this.ruleForm.clientCode = ''
          this.ruleForm.clientCode = ''
          this.goodsData = []
        })
        .catch(() => {
          this.$refs.bigCustomer.blur()
          this.ruleForm.ext19 = this.bigcustomerOrgCode
        })
    },
    //大客户change事件
    getBigCustomerChange(e) {},
    //获取大仓下拉数据
    getBigWarehouseData(query) {
      if (!this.ruleForm.ext19) return false
      let params = {
        unionName: query,
        parentCode: this.ruleForm.ext19,
        customerCode: localStorage.getItem('customerCode'),
      }
      this.bigWarehouseLoading = true
      request
        .post(
          '/mdm/hdMdmCustomerOrgController/findSecondCustomerOrgSelectList',
          params
        )
        .then((res) => {
          if (res.success) {
            this.bigCustomerLoading = false
            this.bigWarehouseList = res.result
          }
        })
        .catch((err) => {
          this.bigWarehouseLoading = false
        })
    },
    //分销单类型change事件
    distributionTypeChange(e) {
      this.distributionType = e
    },
    //大仓change事件
    bigCustomerChange(e) {
      this.ruleForm.clientName = this.bigWarehouseList.find(
        (item) => item.customerOrgCode === e
      ).customerOrgName
    },
    //终端change事件
    bigTerminalChange(e) {
      let item = this.terminalList.find((v) => v.terminalCode === e)

      if (item) {
        this.ruleForm.clientName = item.terminalName
        this.ruleForm.clientType = item.terminalType
      } else {
        this.ruleForm.clientName = ''
        this.ruleForm.clientType = ''
      }
    },
    //获取终端下拉数据
    getTerminalData(query) {
      const {data} = this.modalConfig;

      // if (!this.ruleForm.ext19) return false
      let params = {
        unionName: query,
        customerOrgCode: this.ruleForm.ext19,
        customerCode: Storage.l.get('customerCode'),
      }

      if (data.type === 'edit' || data.type === 'view' ) {
        params.selectedCode = data.clientCode
      }

      this.bigTerminalLoading = true
      request
        .post('/mdm/hdMdmTerminalController/findTerminalSelectList', params)
        .then((res) => {
          if (res.success) {
            this.bigTerminalLoading = false
            this.terminalList = res.result
          }
        })
        .catch((err) => {
          this.bigTerminalLoading = false
        })
    },
    //选择商品提交
    selectGoodsSubmit(data) {
      console.log(data)
      const productCodes = this.goodsData.map((item) => item.productCode)
      data.forEach((item) => {
        if (!productCodes.includes(item.productCode)) {
          this.goodsData.push(item)
        }
      })
    },
    //价格或数量change事件
    priceNumberChange(row) {
      if (row.quantity && row.price) {
        row.ext22 = (row.quantity * row.price).toFixed(2)
      }
    },
    //删除商品
    delGoods() {
      const selectGoods = this.selectRow.map((item) => item.productCode)
      this.goodsData = this.goodsData.filter(
        (item) => !selectGoods.includes(item.productCode)
      )
    },
    //提交
    submitFrom() {
      console.log(21312);
      this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let params = {
              ...this.ruleForm,
              hdSfaVisitStepOrderDistributionItems: this.goodsData,
            }
            console.log('params===',params)
            let url = '/sfa/hdSfaVisitStepOrderDistribution/add'
            if (this.modalConfig.data.id && !this.isDelivery) {
              url = '/sfa/hdSfaVisitStepOrderDistribution/edit'
            }
            if (this.isDelivery) {
              url = '/sfa/hdSfaVisitStepOrderDistribution/deliverGoods'
            }
            if(this.modalConfig.data.type === 'return'){
              url = '/sfa/hdSfaVisitStepOrderDistribution/back'
              params = {
                ...this.ruleForm,
                backItemList: this.goodsData,
              }
            }
            this.btnLoading = true
            request
              .post(url, params)
              .then((res) => {
                if (res.success) {
                  this.btnLoading = false
                  this.$message.success('操作成功！')
                  this.$emit('onSave')
                  this.onClose()
                }
              })
              .catch((err) => {
                this.btnLoading = false
              })
          }
        });
    },
    //获取行项目类型数据字典
    // getTypeItemDict() {
    //   const params = ['sfa_order_line_type']
    //   getBatchDictSelect(params).then((res) => {
    //     if (res.success) {
    //       this.typeItemDict = res.result.sfa_order_line_type
    //     }
    //   })
    // },
    //获取分销单明细
    getDetail() {
      request
        .post(
          `/sfa/hdSfaVisitStepOrderDistribution/getDetail?id=${this.modalConfig.data.id}`,
          {}
        )
        .then((res) => {
          if (res.success) {
            this.ruleForm = res.result
            this.bigcustomerOrgCode = this.ruleForm.ext19
            this.goodsData =
              res.result.hdSfaVisitStepOrderItemDistributionRespVos
            this.distributionType = this.ruleForm.orderSource
            this.getBigWarehouseData()
            this.getTerminalData()
            const params = ['sfa_order_line_type']
            getBatchDictSelect(params).then((res) => {
              if (res.success) {
                const typeItemDict = {}
                res.result.sfa_order_line_type.forEach((item) => {
                  typeItemDict[item.dictCode] = item.dictValue
                })
                console.log(typeItemDict)
                this.goodsData = this.goodsData.map((item) => {
                  item.itmeTypeName = typeItemDict[item.itmeType]
                  return item
                })
                this.showReturnProduct = this.goodsData.some((a) => Math.abs(a.ext24) > 0);
                if(!this.showReturnProduct){
                  const index = this.table_data_head.findIndex(a=>a.prop === 'ext24')
                  this.table_data_head.splice(index,1)
                }
              }
            })
          }
        })
    },
    // 获取退货单详情
    getReturnDetail(){
      request
        .get(
          `/sfa/hdSfaVisitStepOrderDistribution/findBackDetail?id=${this.modalConfig.data.id}`,
          {}
        )
        .then((res) => {
          if (res.success) {
            this.ruleForm = res.result
            this.bigcustomerOrgCode = this.ruleForm.ext19
            this.goodsData =
              res.result.hdSfaVisitStepOrderItemDistributionRespVos
            this.distributionType = this.ruleForm.orderSource
            this.getBigWarehouseData()
            this.getTerminalData()
            const params = ['sfa_order_line_type']
            getBatchDictSelect(params).then((res) => {
              if (res.success) {
                const typeItemDict = {}
                res.result.sfa_order_line_type.forEach((item) => {
                  typeItemDict[item.dictCode] = item.dictValue
                })
                console.log(typeItemDict)
                this.goodsData = this.goodsData.map((item) => {
                  item.itmeTypeName = typeItemDict[item.itmeType]
                  return item
                })
                this.showReturnProduct = this.goodsData.some((a) => Math.abs(a.ext24) > 0);
              }
            })
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.title-text {
  font-size: 16px;
  line-height: 30px;
  font-weight: 600;
  margin-bottom: 10px;
}
.form-container {
  display: flex;
  flex-wrap: wrap;
  .form-item {
    width: 33%;
    .control {
      width: 100%;
    }
  }
}
.btn-container {
  margin-bottom: 10px;
}
</style>
